import { WorkspaceType } from '../../graphql/enums';
import { useCurrentAccount } from './useCurrentAccount';
import { useCurrentWorkspace } from './useCurrentWorkspace';
import { useIsInImpersonateUser } from './useIsInImpersonateUser';

export type CurrentImpersonation = {
  isImpersonating: boolean;
  isUnassigned?: boolean;
  workspaceId?: string;
  workspaceName?: string;
  workspaceType?: WorkspaceType;
  userId?: string;
  userName?: string;
};

export const useCurrentImpersonation = (): CurrentImpersonation => {
  const isInImpersonateUser = useIsInImpersonateUser();
  const currentWorkspace = useCurrentWorkspace(true);
  const { account } = useCurrentAccount();

  if (isInImpersonateUser) {
    const ws = account?.workspace;
    const first = account?.name?.first ?? '';
    const last = account?.name?.last ?? '';
    const userName = `${first} ${last}`.trim() || account?.email || account?.id;
    // workspace comes back as null (not undefined) when the account is
    // unassigned — e.g. after "My History" unsets it — so don't dereference.
    const isUnassigned = ws !== undefined && !ws?.id;
    return {
      isImpersonating: true,
      isUnassigned,
      workspaceId: isUnassigned ? undefined : ws?.id,
      workspaceName: ws?.name,
      workspaceType: ws?.type,
      userId: account?.id,
      userName,
    };
  }

  if (currentWorkspace) {
    const isUnassigned = !currentWorkspace.id;
    return {
      isImpersonating: true,
      isUnassigned,
      workspaceId: isUnassigned ? undefined : currentWorkspace.id,
      workspaceName: currentWorkspace.name,
      workspaceType: currentWorkspace.type,
    };
  }

  return { isImpersonating: false };
};
